(() => {
  const rules = window.PetMealsDeliveryDateRules;
  const config = window.PetMealsDeliveryConfig || {};
  const bypassedForms = new WeakSet();
  let validationInProgress = false;

  if (!rules) return;

  const serverTimeMs = Number(config.serverTimeMs);
  const monotonicStart = window.performance?.now?.() || 0;

  function getCurrentTimeMs() {
    const debugTimeMs = Number(window.__PM_DEBUG_TIME_OVERRIDE_MS__);
    if (Number.isFinite(debugTimeMs) && debugTimeMs > 0) return debugTimeMs;

    if (!Number.isFinite(serverTimeMs)) return Date.now();
    return serverTimeMs + Math.max(0, (window.performance?.now?.() || 0) - monotonicStart);
  }

  function getCartUrl() {
    return `${window.routes?.cart_url || '/cart'}.js`;
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) throw new Error(config.cartCheckFailed);
    return response.json();
  }

  function clearError() {
    document.querySelector('[data-pm-delivery-cutoff-error]')?.remove();
  }

  function showError(trigger, message) {
    clearError();

    const error = document.createElement('div');
    error.className = 'pm-delivery-cutoff-error';
    error.dataset.pmDeliveryCutoffError = '';
    error.setAttribute('role', 'alert');
    error.tabIndex = -1;
    error.textContent = message;

    const host =
      document.getElementById('cart-errors') ||
      trigger?.closest('.drawer__footer, .cart-notification__links, .cart__footer') ||
      trigger?.parentElement ||
      document.body;

    host.prepend(error);
    error.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
    error.focus?.({ preventScroll: true });
  }

  function setBusy(trigger, busy) {
    if (!trigger) return;

    trigger.setAttribute('aria-busy', String(busy));
    if ('disabled' in trigger) trigger.disabled = busy;
  }

  function buildCutoffMessage(validation) {
    const hasInvalidPeriod = validation.invalidPeriodItems.length > 0;
    const earliestDate = rules.formatDateKey(
      hasInvalidPeriod
        ? validation.earliestDayBeforeDateKey
        : validation.earliestDateKey
    );

    return [
      hasInvalidPeriod ? config.cartPeriodUnavailable : config.cartDateUnavailable,
      `${
        hasInvalidPeriod
          ? config.earliestDayBeforeLabel
          : config.earliestDeliveryLabel
      } ${earliestDate}.`,
      config.cartResolution,
    ]
      .filter(Boolean)
      .join(' ');
  }

  async function cartCanCheckout(trigger) {
    try {
      const cart = await fetchCart();
      const validation = rules.validateCart(cart, getCurrentTimeMs());

      if (validation.valid) {
        clearError();
        return true;
      }

      showError(trigger, buildCutoffMessage(validation));
      return false;
    } catch (error) {
      showError(trigger, error.message || config.cartCheckFailed);
      return false;
    }
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      const trigger = event.submitter;
      const isCheckout = trigger?.name === 'checkout' || trigger?.matches?.('[name="checkout"]');

      if (!isCheckout) return;

      if (bypassedForms.has(form)) {
        bypassedForms.delete(form);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (validationInProgress) return;

      validationInProgress = true;
      setBusy(trigger, true);
      const canCheckout = await cartCanCheckout(trigger);
      setBusy(trigger, false);
      validationInProgress = false;

      if (!canCheckout) return;

      bypassedForms.add(form);
      form.requestSubmit(trigger);
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      const link = event.target.closest?.('a[href*="/checkout"]');
      if (!link) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (validationInProgress) return;

      validationInProgress = true;
      setBusy(link, true);
      const canCheckout = await cartCanCheckout(link);
      setBusy(link, false);
      validationInProgress = false;

      if (canCheckout) window.location.href = link.href;
    },
    true
  );
})();
